import { call, put, select, takeLatest } from 'redux-saga/effects'

import * as actions from './actions'
import * as types from './constants'
import { isReadyToPay } from './service'
import featureToggles from 'shared/featureToggles'

function* initReadyToPaySaga() {
    try {
        if (!featureToggles.hasGooglePayEnabled) {
            yield put(actions.googlePayReadyToPaySuccess(false))
            return
        }
        const ready = yield call(isReadyToPay)
        yield put(actions.googlePayReadyToPaySuccess(ready))
    } catch (e) {
        yield put(actions.googlePayReadyToPayFailure(e))
    }
}

export default function* rootSaga() {
    yield takeLatest(types.GOOGLE_PAY_INIT_READY_TO_PAY, initReadyToPaySaga)
}
